export const ServiceTypes = ['google', 'tabelog', 'gnavi', 'hotPepperGourmet', 'retty', 'tripAdvisor', 'yahooPlace'] as const
export type ServiceType = typeof ServiceTypes[number]

export type ServicePreviewBase = {
  errors: string[]
}

export type PaymentMethodPreview = {
  google?: ServicePreviewBase & GooglePaymentMethod
  tabelog?: ServicePreviewBase & TabelogPaymentMethod
  gnavi?: ServicePreviewBase & GnaviPaymentMethod
  hotPepperGourmet?: ServicePreviewBase & HotPepperGourmetMethod
  retty?: ServicePreviewBase & RettyPaymentMethod
  tripAdvisor?: ServicePreviewBase & TripAdvisorMethod
  yahooPlace?: ServicePreviewBase & YahooPlacePaymentMethod
}

export type MethodInfo = {
  available: boolean
  availableValues: string[]
  unavailableValues: string[]
}

export type MethodInfoAvailableOnly = {
  available: boolean
}

export type GooglePaymentMethod = {
  creditCard?: MethodInfo
  debitCard?: MethodInfoAvailableOnly
  cashOnly?: MethodInfoAvailableOnly
  check?: MethodInfoAvailableOnly
  nfcMobile?: MethodInfoAvailableOnly
}

export type TabelogPaymentMethod = {
  creditCard?: MethodInfo
  electronicMoney?: MethodInfo
  qrCodePayment?: MethodInfo
}

export type GnaviPaymentMethod = {
  creditCard?: MethodInfo
  icCardAndOthers?: MethodInfo
}

export type RettyPaymentMethod = {
  creditCard?: MethodInfo
  icCard?: MethodInfo
}

export type HotPepperGourmetMethod = {
  creditCard?: MethodInfo
  electronicMoney?: MethodInfo
  qrCodePayment?: MethodInfo
}

export type TripAdvisorMethod = {
  creditCard?: MethodInfo
  digitalPayment?: MethodInfoAvailableOnly
  cashOnly?: MethodInfoAvailableOnly
}

export type YahooPlacePaymentMethod = {
  creditCard?: MethodInfo
  electronicMoney?: MethodInfo
  qrCodePayment?: MethodInfo
  cashOnly?: MethodInfoAvailableOnly
  transportationElectronicMoney?: MethodInfo
}
